const EditPurpleIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.87868 2.37868C4.44129 1.81607 5.20435 1.5 6 1.5H14.172C14.9675 1.50017 15.7306 1.81631 16.2931 2.37889C16.2931 2.37886 16.2931 2.37893 16.2931 2.37889L18.7071 4.79289C19.0976 5.18342 19.0976 5.81658 18.7071 6.20711C18.3166 6.59763 17.6834 6.59763 17.2929 6.20711L14.8789 3.79311C14.6915 3.60561 14.4371 3.50011 14.172 3.5C14.1719 3.5 14.1721 3.5 14.172 3.5H6C5.73478 3.5 5.48043 3.60536 5.29289 3.79289C5.10536 3.98043 5 4.23478 5 4.5V20.5C5 20.7652 5.10536 21.0196 5.29289 21.2071C5.48043 21.3946 5.73478 21.5 6 21.5H18C18.2652 21.5 18.5196 21.3946 18.7071 21.2071C18.8946 21.0196 19 20.7652 19 20.5C19 19.9477 19.4477 19.5 20 19.5C20.5523 19.5 21 19.9477 21 20.5C21 21.2957 20.6839 22.0587 20.1213 22.6213C19.5587 23.1839 18.7957 23.5 18 23.5H6C5.20435 23.5 4.44129 23.1839 3.87868 22.6213C3.31607 22.0587 3 21.2957 3 20.5V4.5C3 3.70435 3.31607 2.94129 3.87868 2.37868Z"
        fill="#663497"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6669 9.41504C18.2528 8.82915 19.0474 8.5 19.876 8.5C20.7046 8.5 21.4992 8.82915 22.0851 9.41504C22.671 10.0009 23.0001 10.7956 23.0001 11.6241C23.0001 12.4527 22.671 13.2474 22.0851 13.8333L18.0723 17.8421C17.7159 18.1984 17.275 18.4598 16.7913 18.6011L13.921 19.4381C13.921 19.4382 13.921 19.4381 13.921 19.4381C13.6628 19.5134 13.3892 19.518 13.1287 19.4512C12.8682 19.3845 12.6305 19.2489 12.4403 19.0588C12.2502 18.8687 12.1146 18.6309 12.0479 18.3704C11.9812 18.1099 11.9857 17.8363 12.061 17.5782C12.061 17.5782 12.061 17.5782 12.061 17.5782L12.898 14.7082C13.0393 14.2243 13.3003 13.7836 13.6567 13.4272L17.6669 9.41504ZM19.0811 10.8293C19.081 10.8293 19.0811 10.8292 19.0811 10.8293L15.0713 14.8411C14.9525 14.9598 14.8651 15.1069 14.818 15.2681L14.2362 17.2629L16.2307 16.6812C16.2306 16.6813 16.2308 16.6812 16.2307 16.6812C16.3919 16.6341 16.5389 16.547 16.6577 16.4282L20.6709 12.419C20.8815 12.2083 21.0001 11.9221 21.0001 11.6241C21.0001 11.326 20.8817 11.0401 20.6709 10.8293C20.4601 10.6184 20.1741 10.5 19.876 10.5C19.5779 10.5 19.2919 10.6185 19.0811 10.8293Z"
        fill="#663497"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 18.5C7 17.9477 7.44772 17.5 8 17.5H9C9.55228 17.5 10 17.9477 10 18.5C10 19.0523 9.55228 19.5 9 19.5H8C7.44772 19.5 7 19.0523 7 18.5Z"
        fill="#663497"
      />
    </svg>
  );
};

export default EditPurpleIcon;
